import { Link } from "react-router-dom";
import { useSeguroFicha } from "./SeguroFicha";
import usePermissions from "../../hook/usePermissions";

/* ============================================================================
   SEGUROS-PLANES FASE 2 · pestaña Resumen.

   Los datos del seguro que hoy se editan en la sección Seguros, en solo
   lectura, más los tres contadores como accesos a las otras pestañas.

   Es de solo lectura A PROPÓSITO: el formulario de alta/edición del seguro
   sigue siendo el de `Seguros.js` y este rediseño no lo duplica. Duplicarlo
   sería tener dos sitios donde se valida lo mismo, que es exactamente el tipo
   de cosa que este encargo viene a quitar.
   ========================================================================== */

function Dato({ etiqueta, valor }) {
    const vacio = valor === null || valor === undefined || String(valor).trim() === "";
    return (
        <div className="sg-dato">
            <p className="sg-dato__etiqueta">{etiqueta}</p>
            <p className={`sg-dato__valor${vacio ? " sg-dato__valor--vacio" : ""}`}>
                {vacio ? "Sin registrar" : valor}
            </p>
        </div>
    );
}

function Acceso({ a, nombre, numero, pie }) {
    return (
        <Link to={a} className="sg-acceso">
            <span>
                <span className="sg-acceso__nombre">{nombre}</span>
                <p className="sg-acceso__pie">{pie}</p>
            </span>
            {/* Mientras el contador no ha llegado se muestra un guion, no un 0:
                "todavía no lo sé" y "no tiene ninguno" no son lo mismo. */}
            <span className="sg-acceso__numero">
                {Number.isFinite(numero) ? numero : "—"}
            </span>
        </Link>
    );
}

export default function SeguroResumen() {
    const { seguro, idseguro, contadores } = useSeguroFicha();
    const { hasPermission } = usePermissions();

    const base = `/configuracion/seguros/${idseguro}`;

    return (
        <div>
            <div className="sg-resumen__rejilla">
                <Dato etiqueta="Razón social" valor={seguro.razon_social} />
                <Dato etiqueta="RUC" valor={seguro.ruc} />
                <Dato etiqueta="Responsable" valor={seguro.responsable} />
                <Dato etiqueta="Teléfono" valor={seguro.telefono} />
                <Dato etiqueta="Correo electrónico" valor={seguro.correo_electronico} />
                <Dato etiqueta="Dirección" valor={seguro.direccion} />
                <Dato etiqueta="Tipo" valor={seguro.tipoSeguro?.tipo} />
                <Dato
                    etiqueta="Fecha de corte"
                    valor={seguro.fecha_corte ? seguro.fecha_corte_seguro || "Activada" : "No aplica"}
                />
            </div>

            <div className="sg-accesos">
                {hasPermission("procedimientosprecios.view") && (
                    <Acceso
                        a={`${base}/tarifario`}
                        nombre="Tarifario"
                        pie="Precios de esta aseguradora"
                        numero={contadores?.procedimientos}
                    />
                )}
                {hasPermission("planes.view") && (
                    <Acceso
                        a={`${base}/planes`}
                        nombre="Planes"
                        pie="Subconjuntos del tarifario con copago"
                        numero={contadores?.planes}
                    />
                )}
                {hasPermission("promociones.view") && (
                    <Acceso
                        a={`${base}/promociones`}
                        nombre="Promociones"
                        pie="Precios promocionales vigentes"
                        numero={contadores?.promociones}
                    />
                )}
            </div>
        </div>
    );
}
